import { useEffect } from 'react';
import { states } from '@/constants/lifecycle';
import { hasMinimumLength } from '@/utils/resultsHelper';

const useFetchRequestDictionaries = (fetch, category, code, datasetCode, readStatus) => {
  useEffect(() => {
    if (readStatus === states.NONE) {
      fetch(category, code, datasetCode, false);
    }
  }, [category, code, datasetCode, readStatus]);
};

const useFetchRequestDatasetSettings = (fetch, category, code, datasetCode, readStatus, sourceType) => {
  useEffect(() => {
    if (readStatus === states.NONE && hasMinimumLength(datasetCode)) {
      fetch(category, code, datasetCode);
    }
  }, [category, code, datasetCode, readStatus, sourceType]);
};

const useFetchRequestCatalogue = (fetch, category, code, datasetCode, readStatus) => {
  useEffect(() => {
    if (readStatus === states.NONE && hasMinimumLength(datasetCode)) {
      fetch(category, code, datasetCode);
    }
  }, [category, code, datasetCode, readStatus]);
};

export default {
  useFetchRequestDictionaries,
  useFetchRequestDatasetSettings,
  useFetchRequestCatalogue,
};
